<template>
    <div v-if="value.meta">
      <el-divider />
        <h3>Additional Details</h3>
        <el-row :gutter="60">
          <el-col :span="24" :md="12" class="mt-20">
            <el-input-title>Which Club(s) would you like to register with?</el-input-title>
            <el-form-item prop="meta.clubPreference">
              <el-input
                class="mt-05"
                v-model="value.meta.clubPreference"
                placeholder=""
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Country of Birth</el-input-title>
          <el-form-item prop="meta.countryOfBirth">
            <el-input
              class="mt-05"
              v-model="value.meta.countryOfBirth"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>State Organization</el-input-title>
          <el-form-item prop="meta.stateOrganization">
            <el-input
              class="mt-05"
              v-model="value.meta.stateOrganization"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Occupation</el-input-title>
          <el-form-item prop="meta.occupation">
            <el-input
              class="mt-05"
              v-model="value.meta.occupation"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Other Phone Number</el-input-title>
          <el-form-item prop="meta.otherPhoneNumber">
            <el-input
              class="mt-05"
              v-model="value.meta.otherPhoneNumber"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Emergency Contact Relationship</el-input-title>
          <el-form-item prop="meta.emergencyContactRelationship">
            <el-input
              class="mt-05"
              v-model="value.meta.emergencyContactRelationship"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Emergency Contact Other Phone Number</el-input-title>
          <el-form-item prop="meta.emergencyContactOtherPhoneNumber">
            <el-input
              class="mt-05"
              v-model="value.meta.emergencyContactOtherPhoneNumber"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Citizenship or Visa Status</el-input-title>
          <el-form-item prop="meta.citizenshipOrVisaStatus">
            <el-input
              class="mt-05"
              v-model="value.meta.citizenshipOrVisaStatus"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Additional Citizenship or Visa Details</el-input-title>
          <el-form-item prop="meta.additionalCitizenshipOrVisaDetails">
            <el-input
              class="mt-05"
              v-model="value.meta.additionalCitizenshipOrVisaDetails"
              placeholder=""
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>Australian Born Parent or Grandparent</el-input-title>
          <el-form-item prop="meta.australianBornParentOrGrandparent">
            <el-select class="mt-05" v-model="value.meta.australianBornParentOrGrandparent" placeholder="Yes / No">
              <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
            </el-select>
          </el-form-item>
          </el-col>
          <el-col :span="24" :md="12" class="mt-20">
          <el-input-title>International Handball Club Registration?</el-input-title>
          <el-form-item prop="meta.internationalHandballClubRegistration">
            <el-select class="mt-05" v-model="value.meta.internationalHandballClubRegistration" placeholder="Yes / No">
              <el-option v-for="e in yesNoOptions" :label="e.name" :key="e.type" :value="e.type" />
            </el-select>
          </el-form-item>
          </el-col>

          <el-col :span="24" :md="12" class="mt-20">
            <el-input-title required>How do you describe your gender?</el-input-title>
            <el-form-item prop="meta.genderIdentity">
              <el-select
                class="mt-05"
                v-model="value.meta.genderIdentity"
                multiple
                placeholder="Select all that apply"
              >
                <el-option v-for="option in genderIdentityOptions" :key="option" :label="option" :value="option" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" :md="12" class="mt-20">
            <el-input-title required>Are you, or do you describe yourself as LGBTQ+?</el-input-title>
            <el-form-item prop="meta.lgbtqIdentity">
              <el-select
                class="mt-05"
                v-model="value.meta.lgbtqIdentity"
                multiple
                placeholder="Select all that apply"
              >
                <el-option v-for="option in lgbtqIdentityOptions" :key="option" :label="option" :value="option" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" :md="12" class="mt-20">
            <el-input-title required>Do you identify as a person with disability, illness or injury?</el-input-title>
            <el-form-item prop="meta.disabilityIdentity">
              <el-select class="mt-05" v-model="value.meta.disabilityIdentity" placeholder="Select option">
                <el-option v-for="option in disabilityIdentityOptions" :key="option" :label="option" :value="option" />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col
            v-if="value.meta.genderIdentity && value.meta.genderIdentity.includes('Other')"
            :span="24"
            :md="12"
            class="mt-20"
          >
            <el-input-title>Please specify your gender</el-input-title>
            <el-form-item prop="meta.genderIdentityOther">
              <el-input
                class="mt-05"
                v-model="value.meta.genderIdentityOther"
                placeholder="Please specify"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col
            v-if="value.meta.lgbtqIdentity && value.meta.lgbtqIdentity.includes('Yes, not listed')"
            :span="24"
            :md="12"
            class="mt-20"
          >
            <el-input-title>Please specify LGBTQ+ identity</el-input-title>
            <el-form-item prop="meta.lgbtqIdentityOther">
              <el-input
                class="mt-05"
                v-model="value.meta.lgbtqIdentityOther"
                placeholder="Please specify"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24" :md="12" class="mt-20">
            <el-input-title required>Do you identify as an Australian Aboriginal and/or Torres Strait Islander person?</el-input-title>
            <el-form-item prop="meta.indigenousIdentity">
              <el-select class="mt-05" v-model="value.meta.indigenousIdentity" placeholder="Select option">
                <el-option v-for="option in indigenousIdentityOptions" :key="option" :label="option" :value="option" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
    </div>
  </template>
<script>
import playerDetails from '@/mixins/player-details';

export default {
  name: 'handballExtra',
  mixins: [playerDetails],
  props: ['value', 'refs'],
  data() {
    return {
      yesNoOptions: [
        {
          name: 'Yes',
          type: true,
        },
        {
          name: 'No',
          type: false,
        }
      ],
      indigenousIdentityOptions: [
        'No',
        'Yes, Aboriginal',
        'Yes, Torres Strait Islander',
        'Yes, Both',
        'Unsure',
        'Prefer not to say'
      ],
      genderIdentityOptions: [
        'Male',
        'Female',
        'Non-binary',
        'Prefer not to say',
        'Other'
      ],
      lgbtqIdentityOptions: [
        'No',
        'Yes, lesbian, gay, or homosexual',
        'Yes, bisexual',
        'Yes, queer',
        'Yes, trans/gender diverse or a person with trans history',
        'Yes, not listed',
        'Prefer not to say'
      ],
      disabilityIdentityOptions: [
        'Yes',
        'No',
        'Prefer not to say',
        "Don't know"
      ]
    };
  },
  mounted() {
  },
  methods: {
  },
  computed: {
    selectedMemberType() {
      const { meta } = this.value;
      return meta && meta.utasMemberType === 'student' ? 'Student ID' : 'Staff ID';
    }
  }
};
</script>

  <style lang="scss" scoped>

  .el-autocomplete,
  .el-select,
  .el-input {
    width: 100%;
  }

  </style>
